import { NextSeo } from "next-seo"
import WorkIndex from "../../components/workIndex"
import { minifyRecords, base } from "../api/utils/airtable"

export enum AllWorksViews {
  AllWorks = "Published Gallery",
  Overview = "Overview",
  Paintings = "Paintings",
  WorksonPaper = "Works on Paper",
  Sculpture = "Sculpture",
  Photographs = "Photographs",
}
export const fields = ["id", "title", "category", "image_url", "image_preview", "caption"]

const Index = (props: any) => {
  const pageTitle = "Works"

  return (
    <>
      <NextSeo title={pageTitle} />
      <WorkIndex initialWorks={props.works} />
    </>
  )
}

export default Index

export async function getStaticProps() {
  const table = base("All Works")
  try {
    const works = await table.select({ view: AllWorksViews.Overview, fields: fields }).all()

    return {
      props: {
        works: minifyRecords(works),
      },
    }
  } catch (err) {
    console.error(err)
  }
}
